module.exports = __webpack_public_path__ + "static/img/img-install-tag-bus-detail.dc04274.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-bus-detail.svg
// module id = 1784
// module chunks = 1